/* eslint-disable react/prop-types */
function SpotifyPlaylistSection({ spotifyPlaylistId }) {
    if (!spotifyPlaylistId) {
        return null;
    }

    return (
        <section className="mt-14 pb-6">
            <div className="mb-6  mt-6 md:mb-8 md:pt-8">
                <div className="flex items-center gap-3">
                    <p className="items-center gap-2 rounded-full border border-green-500/20 bg-green-500/10 px-3 py-1 font-semibold uppercase tracking-[0.16em] text-green-200">
                    🎵 Playlist del evento
                  </p>
                </div>
                <h2 className="mt-4 text-xl font-black tracking-tight text-white sm:text-2xl">
                  Música que acompaña la experiencia
                </h2>
                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-zinc-400">
                  Escuchá una vista previa de la música del evento antes de comprar tu entrada.
                </p>
            </div>
            <div className="overflow-hidden rounded-2xl border border-zinc-800/70 bg-black shadow-[0_18px_50px_rgba(0,0,0,0.28)]">
                <iframe
                  src={`https://open.spotify.com/embed/playlist/${spotifyPlaylistId}`}
                  width="100%"
                  height="600"
                  frameBorder="0"
                  allowFullScreen=""
                  loading="lazy"
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  title="Playlist de Spotify del evento"
                  className="block h-[600px] w-full sm:h-[560px] lg:h-[420px] xl:h-[380px]"
                />
            </div>
        </section>
    );
}

export default SpotifyPlaylistSection;
